module.exports = __webpack_public_path__ + "img/1950-NAACP Field.54f1bcd6.jpg";